import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';

import { makeStyles, createStyles } from '@material-ui/core/styles';

import { TableBaseStyle } from '../../../baseStyle/tableBaseStyle';

import { GroupListType, GetAllGroupList } from '../../../function/GroupDataModel';

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      width: '95%',
      maxHeight: 'calc(100vh - 240px)',
    },
    //テーブル外枠
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
    },
    //テーブルヘッダセル
    tableHeaderCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    //テーブルボディーセル
    tableCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      minWidth: '100px',
    },
    tableRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
  })
);

type Props = {
  deviceIndex: Number;
  groupInfo: GroupListType;
  onDataSelectAction: (pathname: string, state: any) => void;
};

const GropuListComGrid: React.FC<Props> = (props) => {
  const classes = useStyles();
  const baseClasses = TableBaseStyle();

  const [groupListInfo, setGroupListInfo] = useState<GroupListType>(props.groupInfo);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    GetAllGroupList(props.deviceIndex).then((ret) => {
      setGroupListInfo(ret);
    });
  }, []);

  const handleSelectData = (selectedIndex: number) => {
    if (groupListInfo) {
      var selectRow = groupListInfo.GroupListsComModels[selectedIndex];
      if (selectRow != undefined) {
        console.debug(selectRow);
        var pathname: string = '';
        var state: any = undefined;
        switch (selectRow.FormID) {
          case 1:
            pathname = '/TrendGraphPage';
            state = props.groupInfo.TM_TRD_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 2:
            pathname = '/RealTimeTrendGraphPage';
            state = props.groupInfo.RT_TRD_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 3:
            pathname = '/PhaseCurrentPage';
            state = props.groupInfo.PH_CUR_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 4:
            pathname = '/RawWaveformComparisonPage';
            state = props.groupInfo.SIG_CMP_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 5:
            pathname = '/FFTComparisonPage';
            state = props.groupInfo.FFT_CMP_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 6:
            pathname = '/XYDiagramPage';
            state = props.groupInfo.XY_CMP_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 7:
            pathname = '/RawWaveformComparisonConanPage';
            state = props.groupInfo.SIGC_CMP_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          case 8:
            pathname = '/FFTComparisonConanPage';
            state = props.groupInfo.FFTC_CMP_GROUP_SETs.find((row) => row.GROUP_NO == selectRow.GroupNo);
            break;
          default:
            pathname = '/';
        }

        console.debug(pathname);
        console.debug(state);
        props.onDataSelectAction(pathname, state);
      }
    }
  };

  //行選択の背景色一時置き
  let lineSelection = '';

  return (
    <div>
      <div className={`${lineSelection = classes.tableRow} ${lineSelection = baseClasses.bodyRow}`}></div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table size="small" aria-label="a dense table" stickyHeader className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>No</TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('GropuListComGrid.機能', '機能')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('GropuListComGrid.グループNo', 'グループNo.')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('GropuListComGrid.グループ名', 'グループ名')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupListInfo?.GroupListsComModels.map((row, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => {
                  if (selectedIndex == index + 1) {
                    handleSelectData(index);
                  } else {
                    setSelectedIndex(index + 1);
                  }
                }}
                selected={selectedIndex === index + 1}
                className={lineSelection}
              >
                <TableCell className={classes.tableCell}> {index + 1} </TableCell>
                <TableCell className={classes.tableCell}>{row.FormName}</TableCell>
                <TableCell className={classes.tableCell}>{row.GroupNo}</TableCell>
                <TableCell className={classes.tableCell}>{row.GroupName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default GropuListComGrid;
